var exports = {
  "x6": "AutocompleteItem.module__button___TktTMV",
  "kL": "AutocompleteItem.module__container___TktTMV",
  "wH": "AutocompleteItem.module__selected___TktTMV",
  "Qs": "AutocompleteItem.module__content___TktTMV",
  "Kk": "AutocompleteItem.module__icon___TktTMV",
  "Bm": "AutocompleteItem.module__nameWrapper___TktTMV",
  "UU": "AutocompleteItem.module__name___TktTMV",
  "h_": "AutocompleteItem.module__description___TktTMV",
};

module.exports = exports;
